import { DataStore } from "aws-amplify/datastore";
import { Client, Pet, Vet } from "../../models";
import { PetRepository } from "../interfaces";
import { PetRecord } from "../types";

const toPetRecord = async (p: Pet): Promise<PetRecord> => {
  const vet = await p.vet;
  return {
    id: p.id,
    clientID: p.clientID,
    Name: p.Name,
    Type: p.Type,
    Breed: p.Breed,
    Sex: p.Sex,
    Neutered: p.Neutered,
    VaccinationDue: p.VaccinationDue,
    Notes: p.Notes,
    OffLead: p.OffLead,
    TermsAccepted: p.TermsAccepted,
    vetID: p.vetID,
    vet: vet ? { id: vet.id, name: vet.name, phoneNumber: vet.phoneNumber, address: vet.address } : null,
  };
};

export class DatastorePetRepository implements PetRepository {
  async getForClient(clientID: string): Promise<PetRecord[]> {
    const pets = await DataStore.query(Pet, (p) => p.clientID.eq(clientID));
    return Promise.all(pets.map(toPetRecord));
  }

  async save(pet: PetRecord, isNew: boolean): Promise<PetRecord> {
    if (isNew) {
      const vet = pet.vetID ? await DataStore.query(Vet, pet.vetID) : undefined;
      const input = new Pet({ ...pet, vet: vet ?? undefined });
      const saved = await DataStore.save(input);

      const client = await DataStore.query(Client, pet.clientID);
      if (!client) throw new Error("Failed to save pet: client not found");
      await DataStore.save(
        Client.copyOf(client, (draft) => {
          if (draft.pet && draft.pet.length > 0) {
            draft.pet.push(saved);
          } else {
            draft.pet = [saved];
          }
        })
      );
      return toPetRecord(saved);
    }

    const original = await DataStore.query(Pet, pet.id);
    if (!original) throw new Error("Pet not found to update");
    return toPetRecord(
      await DataStore.save(Pet.copyOf(original, (draft) => { Object.assign(draft, pet); }))
    );
  }

  async delete(id: string): Promise<void> {
    await DataStore.delete(Pet, id);
  }
}
